import React from 'react';
import UserProfileHealthProDesktopView from './user_profile_health_pro_desktop_view';
import UserPreferencesMobileView from './user_preferences_mobile_view';
import { userIsCreator } from '../../services/users';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const UserProfileView = () => {
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  return isSmorgStudio ? (
    <UserProfileHealthProDesktopView />
  ) : (
    <UserPreferencesMobileView />
  );
};

export default UserProfileView;
